import { useLazyQuery,gql } from "@apollo/client";

const GET_MEDICAL_PRACTITIONER_DETAILS=gql`
query GetMedicalFormPractitionerDetails($clientId: Int!, $token: String) {
    getMedicalFormPractitionerDetails(clientId: $clientId, token: $token) {
      success
      message
      data {
        id
        prc_name
        prc_email
        prc_address
        prc_house_no
        prc_street_name
        prc_city
        prc_postcode
        prc_mobile
        prc_phone_country
        prc_country_code
      }
    }
  }
`;

export const GetMedicalPractitinorDetailAction=()=>{
    const [
        getMedicalPractitinorDetailResponseFunction,
        getMedicalPractitinorDetailResponseData
    ]=useLazyQuery(GET_MEDICAL_PRACTITIONER_DETAILS,{
        fetchPolicy: "cache-and-network",
        nextFetchPolicy: "cache-and-network",
        onCompleted:({getMedicalFormPractitionerDetails:responseData})=>{
            if(responseData.success){
                console.log("res",responseData)
            }else{
                console.log("error")
            }
        }
    })

    const getMedicalPractitinorDetailQueryData=getMedicalPractitinorDetailResponseData;

    const initGetMedicalPractitinorDetailData=(data)=>{
        getMedicalPractitinorDetailResponseFunction({
            variables:data
        })
    }
    return {getMedicalPractitinorDetailQueryData,initGetMedicalPractitinorDetailData}
}